import getIdForModel from "helpers/idHelper";

export const fundraiserChange = (e, donationFormData, handlers, formProps) => {
  const {
    recipient,
    fundraisers,
  } = donationFormData;
  const { setTarget } = handlers;
  const { setFieldValue } = formProps;
  const selectedValue = getIdForModel(e.value);
  const recipientId = getIdForModel(donationFormData.recipientId);
  let target;

  if (getIdForModel(selectedValue) === recipientId) {
    target = recipient;
  } else {
    fundraisers.forEach((fundraiser) => {
      if (fundraiser.id === getIdForModel(selectedValue)) {
        target = fundraiser;
      }
    }, selectedValue);
  }

  setTarget(target);
  setFieldValue("targetId", target.id);

  return target;
};
